import { num } from "@/lib/api";

const META = {
  on_hand: { label: "On Hand", color: "#3B82F6" },
  committed: { label: "Committed", color: "#F59E0B" },
  available: { label: "Available", color: "#10B981" },
  incoming: { label: "Incoming", color: "#8B5CF6" },
};

export const AvailabilityCell = ({ kind, value, testId, size = "sm" }) => {
  const meta = META[kind];
  const negative = kind === "available" && value < 0;
  return (
    <span
      data-testid={testId}
      className={`num ${size === "lg" ? "text-2xl" : "text-sm"} font-medium tabular-nums`}
      style={{ color: negative ? "#EF4444" : meta.color }}
    >
      {num(value)}
    </span>
  );
};

/** The four availability numbers, rendered identically everywhere. */
export const AvailabilityBlock = ({ data, testIdPrefix = "avail", compact = false }) => (
  <div
    data-testid={`${testIdPrefix}-block`}
    className={`grid grid-cols-4 ${compact ? "gap-2" : "gap-px bg-slate-200 border border-slate-200"}`}
  >
    {Object.keys(META).map((kind) => (
      <div key={kind} className={compact ? "" : "bg-white px-3 py-2"}>
        <div className="flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 rounded-full" style={{ background: META[kind].color }} />
          <span className="text-[10px] uppercase tracking-widest text-slate-500">{META[kind].label}</span>
        </div>
        <AvailabilityCell
          kind={kind}
          value={data?.[kind] ?? 0}
          size={compact ? "sm" : "lg"}
          testId={`${testIdPrefix}-${kind}`}
        />
      </div>
    ))}
  </div>
);

export const availabilityMeta = META;
